var _path, _path2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRefresh = function SvgRefresh(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 464 464",
    width: 64,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 232c0 128.128906 103.871094 232 232 232v-464c-128.128906 0-232 103.871094-232 232zm0 0",
    fill: "rgb(46, 51, 89)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m232 0v464c128.128906 0 232-103.871094 232-232s-103.871094-232-232-232zm0 0",
    fill: "rgb(74, 77, 114)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFA000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m232 104v43.921875l67.921875-59.921875-67.921875-59.921875v43.921875c-64.703125.015625-123.03125 38.996094-147.789062 98.773438-24.757813 59.78125-11.078126 128.585937 34.667968 174.347656l22.640625-22.640625c-36.625-36.59375-47.589843-91.648438-27.78125-139.480469 19.808594-47.832031 66.488281-79.015625 118.261719-79zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.480469 141.519531c36.625 36.59375 47.589843 91.648438 27.78125 139.480469-19.808594 47.832031-66.488281 79.015625-118.261719 79v-43.921875l-67.921875 59.921875 67.921875 59.921875v-43.921875c64.703125-.015625 123.03125-38.996094 147.789062-98.773438 24.757813-59.78125 11.078126-128.585937-34.667968-174.347656zm0 0"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRefresh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/refresh.6434a4f4.svg";
export { ForwardRef as ReactComponent };